// extracted by mini-css-extract-plugin
module.exports = {"list":"AvatarGroup--list--iQpKc","list-item":"AvatarGroup--list-item--1igP2","listItem":"AvatarGroup--list-item--1igP2","avatar":"AvatarGroup--avatar--2raym"};